import Immutable from 'immutable';

// constants
import { GET_BANNERS } from '../constants/bannersTypes';

// lib
import httpReducer from '../lib/httpReducer';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case GET_BANNERS: return httpReducer(state, action);
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/banners.js